import React from 'react';
import PropTypes from 'prop-types';
import 'd3';
import NVD3Chart from 'react-nvd3';
import Chart from '../../../components/Chart';

import {
  getTotalUndergraduateEnrollment,
  donutCallback,
  donutTooltip,
  formatValueAsPercent,
  formatDonutHalves,
} from '../../../utils/charts';

class ResidencyStatus extends React.PureComponent {
  static props = {
    undergraduateEnrollment: PropTypes.object,
    outOfStateData: PropTypes.string,
    isCamino: PropTypes.bool,
  };

  onRenderEnd = () => {
    const { undergraduateEnrollment } = this.props;

    const totalUndergraduateEnrollment = getTotalUndergraduateEnrollment(
      undergraduateEnrollment,
    ).toFixed(0);

    donutCallback('#residency-status-data-container', totalUndergraduateEnrollment, [
      'Total Undergrad',
      'Students',
    ]);
  };

  getResidencyPercData = (outOfStateData) => {
    const residencyPercData = [];
    if (!outOfStateData || Number.isNaN(Number(outOfStateData))) {
      return residencyPercData;
    }

    residencyPercData.push(Math.round(Number(outOfStateData)));
    residencyPercData.push(100 - Math.round(Number(outOfStateData)));
    return residencyPercData;
  };

  render() {
    const { outOfStateData, isCamino } = this.props;
    const data = formatDonutHalves(
      this.getResidencyPercData(outOfStateData),
      ['Out-Of-State', 'In-State'],
      isCamino,
    );
    return data.length > 0 ? (
      <Chart data={data} title="Residency Status" id="residency-status-data-container">
        <NVD3Chart
          id="genderData"
          type="pieChart"
          datum={data}
          x="line1"
          y="value"
          margin={{ top: 0, left: 0, bottom: 0, right: 0 }}
          donut
          showLegend={false}
          labelType="value"
          donutRatio={0.5}
          showLabels
          showValues
          duration={250}
          labelThreshold={0.05}
          growOnHover
          renderEnd={this.onRenderEnd}
          valueFormat={formatValueAsPercent}
          tooltip={donutTooltip}
          padAngle={0.005}
        />
      </Chart>
    ) : null;
  }
}

export default ResidencyStatus;
